import React, { useState } from 'react';
import cssModule from './index.module.scss';
import FlyingEnvelope from '@/components/FlyingEnvelope';

/**
 * 悬浮注册按钮组件
 * 包含图标和文字的胶囊形状按钮
 * hover时展开显示完整内容
 */
function FloatingRegisterButton() {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    // 跳转到注册页面
    window.open('/customerregistration', '_blank')
  };

  return (
    <div 
      className={`${cssModule['floating-register']} ${isHovered ? cssModule['floating-register--expanded'] : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div className={cssModule['floating-register__container']}>
        {/* 勾选图标 */}
        {/* <img 
          className={cssModule['floating-register__icon']} 
          src={getJdiOSFile('mubla1/110610227100827099.png')} 
          alt="register icon"
        /> */}
        <div className={cssModule['floating-register__icon']}>
          <FlyingEnvelope size={30} color="#e2231a" />
        </div>
        {/* 注册文字 - hover时显示 */}
        <span className={cssModule['floating-register__text']}>{TLT('立即注册')}</span>
      </div>
    </div>
  );
}

export default FloatingRegisterButton;

